import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "../../http/axios";

import Pagination from "../UI/Pagination";
import Dialog from "../UI/Dialog";
import SearchForm from "../UI/SearchForm";
import Spinner from "../UI/Spinner";
import { links } from "../../utils/constants";
import {
  getCustomers,
  deleteCustomer,
  changeDeleteStatus
} from "../../store/actions";

class Customers extends Component {
  state = {
    currentPage: 1,
    removingCustomerId: null,
    searchValue: null,
    isDeleteDialogOpen: false
  };

  componentDidMount() {
    this.getCustomers();
  }

  getCustomers = () => {
    const page = this.state.currentPage;
    const searchValue = this.state.searchValue;
    this.props.getCustomers(page, searchValue);
  };

  goToCustomerPage = id => {
    this.props.history.push(links.customer(id));
  };

  pageChangeHandler = page => {
    this.setState({ currentPage: page.selected + 1 });
    this.props.getCustomers(page.selected + 1, null);
  };

  // onDeleteCustomer = () => {
  //     this.props.deleteCustomer(this.state.removingCustomerId).then(res => {
  //         this.getCustomers();
  //         this.setState({ isDeleteDialogOpen: false, removingCustomerId: null });
  //     });
  // };

  onDeleteCustomer = () => {
    this.props.changeDeleteStatus(this.state.removingCustomerId).then(res => {
      this.getCustomers();
      this.setState({ isDeleteDialogOpen: false, removingCustomerId: null });
    });
  };

  getCSV = () => {
    axios({
      url: "/customers/?show_all=true",
      method: "GET",
      headers: {
        Authorization: "JWT " + this.props.token,
        Accept: "text/csv"
      }
    }).then(response => {
      const replaceData = response.data
        .replace(/False/g, "No")
        .replace(/True/g, "Yes");

      const url = window.URL.createObjectURL(new Blob([replaceData]));
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", "Customers.csv");
      link.click();
    });
  };

  onSubmitSearchHandler = searchValue => {
    this.props.getCustomers(1, searchValue);
  };

  renderPagination = () => {
    let pagination = null;
    if (this.props.customersPageCount && this.props.customersPageCount > 1) {
      pagination = (
        <Pagination
          pageChangeHandler={this.pageChangeHandler}
          driversPageCount={this.props.customersPageCount}
        />
      );
    }
    return pagination;
  };

  renderCostumersTableData = () => {
    let customersTable = null;
    const { customers } = this.props;
    if (customers) {
      customersTable = customers.map(customer => {
        const {
          id,
          type,
          relationship_manager_name,
          relationship_manager_phone_number
        } = customer;
        return (
          <tr key={id}>
            <td onClick={() => this.goToCustomerPage(id)}>{id}</td>
            <td onClick={() => this.goToCustomerPage(id)}>{type}</td>
            <td onClick={() => this.goToCustomerPage(id)} className="underline">
              {customer.restaurant.name}
            </td>
            <td onClick={() => this.goToCustomerPage(id)} className="underline">
              {customer.restaurant.phone_number}
            </td>
            <td onClick={() => this.goToCustomerPage(id)}>
              {customer.restaurant.agreed_radius}
            </td>
            <td onClick={() => this.goToCustomerPage(id)}>
              {relationship_manager_name}
            </td>
            <td onClick={() => this.goToCustomerPage(id)}>
              {relationship_manager_phone_number}
            </td>
            <td>
              <Link to={links.editCustomer(id)} className="px-10">
                <i className="fa fa-pencil" />
              </Link>
              <a
                onClick={() =>
                  this.setState({
                    isDeleteDialogOpen: true,
                    removingCustomerId: id
                  })
                }
                className="px-10 color-red"
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-trash font-md" />
              </a>
            </td>
          </tr>
        );
      });
    }

    return customersTable;
  };

  onSearchChangeHandler = searchValue => {
    this.setState({ searchValue });
  };

  render() {
    if (!this.props.customers) return <Spinner />;
    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <SearchForm
                onChange={this.onSearchChangeHandler}
                onSubmit={this.onSubmitSearchHandler}
              />

              <div className="col-xs-4 text-center">
                <h1 className="color-grey">Customers</h1>
              </div>

              <div className="col-xs-4 text-right">
                <Link
                  to="/customers/add"
                  className="btn filled primary min-220"
                >
                  <i className="fa fa-plus font-sm mr-10" />
                  Add new customer
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container box py-15">
          <div className="table customerList withHover">
            <table>
              <thead>
                <tr>
                  <th>Customer ID</th>
                  <th>Customer Type</th>
                  <th>Customer Name</th>
                  <th>Customer Mobile Number</th>
                  <th>Agreed Radius</th>
                  <th>Relationship Manager Name</th>
                  <th>Relationship Manager Mobile Number</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>{this.renderCostumersTableData()}</tbody>
            </table>
          </div>
          <div className="text-right mt-20">
            <a
              className="flex-align-y font-sm w-800"
              style={{ cursor: "pointer" }}
              onClick={this.getCSV}
            >
              <i className="fa fa-download mr-10" />
              Download Excel File
            </a>
          </div>
          {this.renderPagination()}
        </div>

        <Dialog
          open={this.state.isDeleteDialogOpen}
          handleClose={() => this.setState({ isDeleteDialogOpen: false })}
        >
          <React.Fragment>
            <div className="popup-title">
              <h2>Are you sure you want to delete this customer?</h2>
            </div>

            <div className="popup-meta flex justify-end">
              <button
                type="button"
                className="no-style w-600 pointer mx-20"
                onClick={() =>
                  this.setState({
                    isDeleteDialogOpen: false,
                    removingCustomerId: null
                  })
                }
              >
                No
              </button>
              <button
                onClick={this.onDeleteCustomer}
                type="button"
                className="btn filled primary min-120"
              >
                Yes
              </button>
            </div>
            <button
              className="no-style close-btn"
              onClick={() =>
                this.setState({
                  isDeleteDialogOpen: false,
                  removingCustomerId: null
                })
              }
            >
              ×
            </button>
          </React.Fragment>
        </Dialog>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    customers: state.customer.customers,
    customersPageCount: state.customer.customersPageCount,
    token: state.auth.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCustomers: (page, searchValue) =>
      dispatch(getCustomers(page, searchValue)),
    deleteCustomer: customerId => dispatch(deleteCustomer(customerId)),
    changeDeleteStatus: customerId => dispatch(changeDeleteStatus(customerId))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Customers);



// WEBPACK FOOTER //
// ./src/components/Customer-administrator/Customers.js